import React from 'react';
import { injectIntl } from 'react-intl';
import Tooltip from '@Components/Tooltip';
import t from 'prop-types';
import maskSalary from 'maskSalary';
import { useAppContext } from 'appContext';

function AverageSalary({ salary, count, intl }) {
  const { currencySettings: { currencySign, salarySeparator } } = useAppContext();

  return (
    <div className="salary-block salary-block__average" data-testid="average-salary">
      <div className={`salary-block__icon icon icon--inline icon__salary fill-brand--${process.env.REACT_APP_COUNTRY === 'sph' ? 'orange' : 'blue'}`}>
        <svg aria-label={intl.formatMessage({ id: 'Icon.Location.AriaLabel' })}>
          <use
            xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#marker"
          />
        </svg>
      </div>
      <h2 className="title--s">
        {intl.formatMessage({ id: 'Salary.Average.Title' })}
      </h2>
      <div className="salary-block__salary_info">
        <span className={`salary-block__salary_num text-brand-primary ${process.env.REACT_APP_COUNTRY === 'sph' ? 'title--m-slim' : 'title--l'}`}>
          {currencySign}
          {maskSalary(Math.round(salary), salarySeparator)}
        </span>
        <span>
          {intl.formatMessage({ id: 'Salary.PerYear.Text' })}
          <Tooltip
            content={intl.formatMessage({ id: 'Tooltip.GrossSalary.Label' })}
            position={`${process.env.REACT_APP_COUNTRY === 'sph' ? 'left' : 'center'}`}
          />
        </span>
      </div>
      <p>
        {intl.formatMessage({ id: 'Salary.Average.Description' }, { count: maskSalary(count, salarySeparator) })}
      </p>
    </div>
  );
}

AverageSalary.propTypes = {
  salary: t.number.isRequired,
  count: t.number.isRequired,
};

export default injectIntl(AverageSalary);
